import { CommonConfig } from "../shared/common-config";

export class NavigationConfig extends CommonConfig {
    navigationMenuConfigPath = './assets/configurations/navigation-menu.json';

}
